/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type QuestionType = "HelpWithFindingUninterruptedTimeToFocus" | "HelpWithSchedulingExternalMeetingsEffortlessly" | "HelpWithSettingHealthyWorkLifeBoundaries" | "HelpWithSimplifyingSchedulingWithCoworkers" | "HelpWithSomethingElse" | "HowDidYouHearAboutClockwise" | "HowManyPeopleOnTeam" | "WhatIsYourCurrentPosition" | "WhatTypeOfWorkDoYouDo" | "%future added value";
export type ResponseType = "AccountingOrFinance" | "Administrative" | "Between10And15" | "Between15And20" | "Between5And9" | "BusinessOwner" | "Checked" | "CustomerSupport" | "DesignOrUxResearch" | "DirectorOrDepartmentLeader" | "ExecutiveOrBusinessLeader" | "FoundOnline" | "FriendOrFamily" | "IDoNotKnow" | "IDoNotWorkOnAnyTeams" | "IndividualContributor" | "InternetSearch" | "It" | "Legal" | "LessThan5" | "Manager" | "Marketing" | "MoreThan20" | "MyMeetingsOnAutopilot" | "OnlineAdvertisement" | "Operations" | "Other" | "PeopleOpsOrHr" | "ProductManagement" | "ProgramOrProjectManagement" | "Recruiting" | "SalesOrBusinessDevelopment" | "SocialMedia" | "SoftwareEngineering" | "TeammateAutopilot" | "TeammateCalendar" | "TeammateFocusTime" | "TeammateInvited" | "TeammatePersonalCalendar" | "TeammatePrepTime" | "TeammateSlackStatus" | "TeammateTravelTime" | "Unchecked" | "VpOrDivisionLeader" | "%future added value";
export type SaveUserSurveyResponseWrapperMutationInput = {
    clientMutationId?: string | null | undefined;
    userSurveyResponseWrapper: UserSurveyResponseWrapperInput;
};
export type UserSurveyResponseWrapperInput = {
    id: string;
    userSurveyResponses: Array<UserSurveyResponseInput>;
};
export type UserSurveyResponseInput = {
    freeformResponse?: string | null | undefined;
    questionText?: string | null | undefined;
    questionType?: QuestionType | null | undefined;
    responseText?: string | null | undefined;
    responseType?: ResponseType | null | undefined;
};
export type SaveUserSurveyResponseWrapperMutationVariables = {
    input: SaveUserSurveyResponseWrapperMutationInput;
};
export type SaveUserSurveyResponseWrapperMutationResponse = {
    readonly userSurveyResponseWrapperMutations: {
        readonly userSurveyResponseWrapper: {
            readonly id: string;
            readonly userSurveyResponses: ReadonlyArray<{
                readonly questionType: QuestionType | null;
                readonly responseType: ResponseType | null;
                readonly questionText: string | null;
                readonly responseText: string | null;
                readonly freeformResponse: string | null;
            }>;
        };
    } | null;
};
export type SaveUserSurveyResponseWrapperMutation = {
    readonly response: SaveUserSurveyResponseWrapperMutationResponse;
    readonly variables: SaveUserSurveyResponseWrapperMutationVariables;
};



/*
mutation SaveUserSurveyResponseWrapperMutation(
  $input: SaveUserSurveyResponseWrapperMutationInput!
) {
  userSurveyResponseWrapperMutations(input: $input) {
    userSurveyResponseWrapper {
      id
      userSurveyResponses {
        questionType
        responseType
        questionText
        responseText
        freeformResponse
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "SaveUserSurveyResponseWrapperMutationPayload",
            "kind": "LinkedField",
            "name": "userSurveyResponseWrapperMutations",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserSurveyResponseWrapper",
                    "kind": "LinkedField",
                    "name": "userSurveyResponseWrapper",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserSurveyResponse",
                            "kind": "LinkedField",
                            "name": "userSurveyResponses",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "questionType",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "responseType",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "questionText",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "responseText",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "freeformResponse",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "SaveUserSurveyResponseWrapperMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "SaveUserSurveyResponseWrapperMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "b1bca09fe4ed130adc4eec930c2469f3",
            "id": null,
            "metadata": {},
            "name": "SaveUserSurveyResponseWrapperMutation",
            "operationKind": "mutation",
            "text": "mutation SaveUserSurveyResponseWrapperMutation(\n  $input: SaveUserSurveyResponseWrapperMutationInput!\n) {\n  userSurveyResponseWrapperMutations(input: $input) {\n    userSurveyResponseWrapper {\n      id\n      userSurveyResponses {\n        questionType\n        responseType\n        questionText\n        responseText\n        freeformResponse\n      }\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = 'a34b38a3a96982adc57bfcb1447141b6';
export default node;
